/** The "Your workspaces need you to sign in with" page (NG-3331). */
export const SSO_REQUIRED_PATH = "/accounts/sso-required";

/** The API's 403 code for a workspace this session's sign-in doesn't open (NG-3330). */
const SSO_SIGN_IN_REQUIRED_CODE = "sso_sign_in_required";

/**
 * Where a refused request sends the person, or `null` to leave the refusal with
 * the page that asked.
 *
 * Only a refusal of the workspace the person is looking at (the URL's first
 * segment) moves them: a background read naming another workspace must not pull
 * them off a page that works. The page they were on rides along as `next_path`,
 * so an SSO sign-in brings them back to it.
 */
export function ssoRequiredRedirect(
  status: number | undefined,
  body: unknown,
  pathname: string,
): string | null {
  if (status !== 403 || typeof body !== "object" || body === null) return null;
  const { code, workspace } = body as { code?: unknown; workspace?: unknown };
  if (code !== SSO_SIGN_IN_REQUIRED_CODE || typeof workspace !== "string") return null;
  if (pathname === SSO_REQUIRED_PATH) return null;
  const currentWorkspace = pathname.split("/").filter(Boolean)[0];
  if (currentWorkspace !== workspace) return null;
  return `${SSO_REQUIRED_PATH}?${new URLSearchParams({ next_path: pathname }).toString()}`;
}
